import { combineReducers } from 'redux';
import assessmentStatusWidgetReducer from '../../features/dashboard/store/slices/assessmentStatusWidgetSlice';
import assessmentOutcomesWidgetReducer from '../../features/dashboard/store/slices/assessmentOutcomesWidgetSlice';
import reportsReducer from '../../components/Reports/state';
import unitsReducer from '../slices/CurriculumUnits';
import classroomReducer from '../slices/classroomSlice';
import weeklyPlanReducer from '../slices/WeeklyPlanSlice';
import assignmentModalReducer from '../slices/AssignmentModalSlice';
import scheduleAssessmentReducer from '../../features/dashboard/store/slices/scheduleAssessmentSlice';
import benchmarkReportReducer from '../../features/reports/benchmark_report/store/slices/benchmarkReportSlice';
import UserDataReducer from '@/store/slices/UserDataSlice';
import UserEntitlementReducer from '@/store/slices/UserEntitlementSlice';
import dashboardWidgetReducer from "../slices/DashboardWidgetSlice";
import alertsReducer from "../slices/AlertsSlice";
import calendarReducer from "../slices/CalendarSlice";
import toastReducer from "../slices/ToastSlice";

export const rootReducer = combineReducers({
  reports: reportsReducer,
  units: unitsReducer,
  weeklyPlan: weeklyPlanReducer,
  classroom: classroomReducer,
  assessmentStatusWidget: assessmentStatusWidgetReducer,
  assessmentOutcomesWidget: assessmentOutcomesWidgetReducer,
  assignmentModal: assignmentModalReducer,
  scheduleAssessment: scheduleAssessmentReducer,
  benchmarkReport: benchmarkReportReducer,
  userData: UserDataReducer,
  userEntitlement: UserEntitlementReducer,
  dashboardWidget: dashboardWidgetReducer,
  alerts: alertsReducer,
  calendar: calendarReducer,
  toast: toastReducer,
  // Add other slice reducers here
});

export default rootReducer;